import globals from "../../globals"

export default class ProgramSettings {

  id: number
  NQMS: boolean = false
  ADA: boolean = false

  async save() {
    let response = await globals.api.post(`/a/app/program/${this.id}/settings`, {
      nqms: this.NQMS,
      ada: this.ADA
    })
  }

  load(data) {
    this.NQMS = data.attributes.NQMS == 1
    this.ADA = data.attributes.ADA == 1
  }

}